import TenantFilesNotes from './TenantFilesNotes'

export default TenantFilesNotes
